export const NEW = 'new';
export const ALL = 'all';
export const PHONE_NO_REGEX = /^[0-9\- ]{8,14}$/;

export const SUPERUSER_LOGIN_NAME = 'mobileo';

// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_TIME_FORMAT_SHORT = 'YYYY-MM-DD HH:mm';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const YEAR_MONTH_FORMAT = 'YYYY-MM';
export const TIME_FORMAT = 'HH:mm:ss';
export const TIME_FORMAT_SHORT = 'HH:mm';

export const SERVER_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';

export const MONTH_DAY = 'MMMM D';
export const DAY = 'DD';

export const CLIENT_TYPE = 'C';

export const MAX_EXCEL_EXPORT_ROWS = 500000;

export const IR_STATUSES = {
  NEW: 'New',
  APPROVED: 'Approved',
  PENDING: 'pending',
};

export const UNIT_TYPES = {
  SITES: 'sites',
  EMPLOYEES: 'employees',
  MOBILE_PATROLS: 'mobile_patrols',
};

export const CHARTS_TYPES = {
  ENTITY: 'entity',
  EVENT: 'event',
};

export const CHECKPOINT_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  NO_TAG_ASSIGNED: 'no_tag_assigned',
  MASTER: 'master',
};

export const TABLE_NAMES = {
  EMPLOYEES: 'employees',
  CONTACTS: 'contacts',
  SITES: 'sites',
  CLIENTS: 'clients',
  TOURS: 'tours',
  TASKS: 'tasks',
  VISITORS: 'visitors',
  VISITOR_LOG: 'visitor_log',
  MOBILE_PATROLS: 'mobile_patrols',
  ADMINISTRATORS: 'administrators',
  BRANCHES: 'branches',
};

export const TOUR_TYPES = {
  STATIC: 'static',
  DYNAMIC: 'dynamic',
};

export const SITE_PLAN_ITEM_TYPES = {
  AREA: 'area',
  CHECKPOINT: 'checkpoint',
  SITE: 'site',
};

export const REPEAT_TYPES = {
  NEVER: 'never',
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
};

export const SCHEDULE_MONTH_TYPE = {
  DAY_OF_MONTH: 'day_of_month',
  WEEKDAY_OF_MONTH: 'weekday_of_month',
};

export const SHIFT_STATUSES = {
  IN_PROGRESS: 'shift_in_progress',
  TERMINATED: 'shift_terminated',
  ENDED: 'shift_ended',
};

export const ENTITY_SITE_TYPE = {
  SINGLE_SITE: 'SINGLE_SITE',
  MULTIPLE_SITES: 'MULTIPLE_SITES',
};

export const ENTITY_STATUS = {
  ACTIVE: 'A',
  SUSPENDED: 'S',
  DELETED: 'D',
};

export const FORM_RESULTS_STATUSES = {
  SUBMITTED: 'submitted',
  UNSUBMITTED: 'unsubmitted',
};

export const VISIT_REGISTRATION_TYPES = {
  ENTRANCE_ONLY: 'entrance_only',
  ENTRANCE_AND_EXIT: 'entrance_and_exit',
};

export const PREDEFINED_RANGES = {
  THIS_YEAR: 'this_year',
  LAST_YEAR: 'last_year',
  THIS_MONTH: 'this_month',
  LAST_MONTH: 'last_month',
};

export const BI_TOURS_VIEW_TYPES = {
  MONTHLY: 'monthly',
  BAR_CHART: 'bar_chart',
  LIST: 'list',
};

export const BI_TOURS_BY_SITE_VIEW_TYPES = {
  BY_TOUR: 'by_tour',
  BY_EMPLOYEE: 'by_employee',
  TOUR_LOG: 'tour_log',
};

export const BI_TOURS_UNIT_TYPE = {
  ALL: 'all',
  EMPLOYEE: 'employees',
  MOBILE_PATROL: 'mobile_patrols',
};

export const SHIFTS_UNIT_TYPE = {
  ALL: 'all',
  EMPLOYEE: 'employees',
  MOBILE_PATROL: 'mobile_patrols',
};

export const SITE_SCAN_TYPES = {
  QR_CODE: 'qr_code',
  NFC: 'nfc',
  NONE: 'none',
};

export const EMPLOYEE_TAG_TYPE = {
  QR_CODE: 'qr_code',
  NFC: 'nfc',
  NONE: 'none',
};

export const QR_CODE_PRINT_SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
};

export const PDF_REPORTS_VIEW_TYPE = {
  ALL: 'all',
  SITE: 'site',
  MOBILE_UNIT: 'mobile_unit',
  CLIENT: 'client',
};

export const BI_NOTEBOOK_NOTES_VIEW_TYPES = {
  MONTHLY: 'monthly',
  PIE_CHART: 'pie_chart',
  BAR_CHART: 'bar_chart',
  TABLE: 'table',
};

export const BI_SITE_VISITS_VIEW_TYPES = {
  MONTHLY: 'monthly',
  BAR_CHART: 'bar_chart',
  TABLE: 'table',
};

export const PDF_REPORTS_TYPES = {
  FORM_REPORT: 'form_report',
  INCIDENT_REPORT: 'incident_report',
  SHIFT_REPORT: 'shift_report',
  MOBILE_PATROL_SHIFT_REPORT_EXTENDED: 'mobile_unit_shift_report_extended',
  MOBILE_UNIT_SHIFT_REPORT_EXTENDED: 'mobile_unit_shift_report_extended',
  TOUR_REPORT: 'tour_report',
  DAILY_SITE_VISITS_REPORT: 'daily_site_visits_report',
  SITE_VISIT_REPORT: 'site_visit_report',
  MOBILE_UNIT_SITE_VISIT_SUMMARY_EXTENDED_REPORT: 'mobile_unit_site_visit_summary_report_extended',
  MOBILE_PATROL_SHIFT_REPORT: 'mobile_unit_shift_report',
  MOBILE_UNIT_SHIFT_REPORT: 'mobile_unit_shift_report',
  DAILY_SITE_ACTIVITY_REPORT: 'daily_site_activity_report',
};

export const PDF_REPORTS_STATUSES = {
  HAS_RECIPIENTS: 'has_recipients',
  NO_RECIPIENTS: 'no_recipients',
};

export const EMAIL_RECIPIENTS_MODAL_TYPES = {
  ADMINISTRATORS_AND_EMPLOYEES: 'administrators_and_employees',
  CONTACTS: 'contacts',
};

export const NO_QR_CODE_STATUS = 'no_qr_code';

export const EMAIL_NOTIFICATIONS_TAB_RELEASE_DATE = '2023-10-17';
export const EMPLOYEE_PROFILE_RELEASE_DATE = '2023-11-20';

export const HIDE_PROFESSIONAL_TAB_ACCOUNTS = ['plutronix', 'qns', 'mobileo'];
export const EMPLOYEE_ID_ACCOUNTS = ['mobileotest', 'gcdemo', 'ggseguridad'];
